import { Block } from '../../models/block';

class FlightBarWallSubTotalBlock extends Block {
    getStyles = () => ({
        ...this.styles,
    });
}
 
export default FlightBarWallSubTotalBlock;
